import type { EntityComponent } from "../world/components";
import type { EntityKind } from "../world/Entity";

export interface EntityDefinitionEntry {
  readonly definitionId: string;
  readonly kind: EntityKind;
  readonly asset: string;
  readonly size: { readonly width: number; readonly height: number };
  readonly components: readonly EntityComponent[];
}

export class EntityDefinitionRegistry {
  private readonly definitions = new Map<string, EntityDefinitionEntry>();

  register(definition: EntityDefinitionEntry): void {
    this.definitions.set(definition.definitionId, definition);
  }

  get(definitionId: string): EntityDefinitionEntry | undefined {
    return this.definitions.get(definitionId);
  }

  has(definitionId: string): boolean {
    return this.definitions.has(definitionId);
  }
}
